// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1PJa0","header":"ReportDetails_header__sUb3s","title":"ReportDetails_title__3UlvA","left":"ReportDetails_left___dsKB"};